import React, { useEffect, useState } from 'react';
import {
  echartsContent,
  handleMentionData,
  handleSumData,
  mathFormat,
} from '@/pages/opinion/utils';
import { useHistory, useIntl } from 'umi';
import {
  formatter,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { baseColors, extendColors } from '@/pages/opinion/constants';
import { getNewStatsDetailFilter } from '@/pages/opinion/pages/stats/utils';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';
import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';

export default function Keyword(props: {
  data: any;
  filter: any;
  handleStatsDetailOnClick?: any;
  translateKeywordMap?: any;
  chartClickAble?: boolean;
  height?: number;
  keywordClick?: (params: any) => void;
}) {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { goPage } = useDrilldownParams();
  const colorArr = [...baseColors, ...extendColors];

  const {
    data: keywordLineData,
    filter,
    translateKeywordMap,
    handleStatsDetailOnClick,
    chartClickAble = true,
    height = 300,
    keywordClick,
  } = props;

  const axisTimeTypeMap: {
    [key: string]: 'day' | 'year' | 'days' | 'hourly';
  } = {
    daily: 'days',
    weekly: 'days',
    hourly: 'hourly',
    year: 'year',
  };
  const axisTimeType = axisTimeTypeMap[filter.date_type] || 'year';

  const lineData = handleMentionData(
    keywordLineData?.timeline_keywords,
    axisTimeType,
  );
  const lineSumData = handleSumData(
    keywordLineData?.time_sum_line,
    axisTimeType,
  );

  const chartData = lineData?.newArr;
  const timeData = lineData?.timeArr;
  const sumData = lineSumData;

  const [options, setOptions] = useState({});

  // console.log('TopicKeywordCard', lineData, lineSumData);

  useEffect(() => {
    const newLegendData: Array<any> = [];
    const newChardata = chartData.map((v, i) => {
      const color = colorArr[i];
      newLegendData.push({
        name: translateKeywordMap?.[v.name] || v.name,
        icon: 'circle',
        itemStyle: {
          color: color,
        },
      });

      return {
        ...v,
        name: translateKeywordMap?.[v.name] || v.name,
        itemStyle: {
          color: color,
        },
      };
    });

    const option = {
      color: colorArr,
      title: {
        text: formatMessage({ id: 'Mentions' }),
        textStyle: {
          fontWeight: '400',
          fontSize: 12,
          color: '#838697',
        },
      },
      axisPointer: getAxisPointer((data) => {
        return formatTimeXAxisText(data.value, filter?.date_type || 'daily');
      }),
      tooltip: {
        formatter: (params: any) => {
          const sumKey = params[0].axisValue;
          const timeText = listTimeTitleFunc(
            sumKey,
            filter?.date_type || 'daily',
          );
          params.sort((a, b) => b.value - a.value);

          const records = [];
          for (let i = 0; i < params.length; i++) {
            const { value: dauValue, marker, seriesName } = params[i];

            const name = seriesName?.replace('<', '&lt;').replace('>', '&gt;'); // 替换尖括号

            records.push({
              type: `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;${name}`,
              score: mathFormat(dauValue),
            });
          }

          return formatter({
            footerText: formatMessage({ id: 'Mentions: not dedupilcated' }),
            tables: [
              {
                records,
                columns: [
                  {
                    key: 'type',
                    header: timeText,
                  },
                  {
                    key: 'score',
                    header: formatMessage({ id: 'Mentions' }),
                    align: 'right',
                    weight: 'bold',
                  },
                ],
              },
            ],
          });
        },
      },
      legend: {
        data: newLegendData,
      },
      grid: {
        top: '15%',
        left: '1%',
        right: '2%',
        bottom: '11%',
      },
      xAxis: {
        axisLabel: {
          align: 'center',
          formatter: (value: any) =>
            formatTimeXAxisText(value, filter.date_type),
        },
        boundaryGap: ['20%', 0],
        data: timeData,
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value: any) => {
            return echartsContent(value);
          },
        },
      },
      series: newChardata,
    };

    setOptions(option);
  }, [keywordLineData]);

  return (
    <EChartCommon
      options={options}
      height={height}
      eventsDict={{
        click: (params: any) => {
          if (!chartClickAble) return;
          if (keywordClick) {
            return keywordClick(params);
          }

          const dataType = 'keyword';
          const statsDetailType = 'performance-keyword-timeline';

          const { location } = history;

          if (location?.pathname === '/opinion/Stats/Detail') {
            handleStatsDetailOnClick?.({
              statsDetailType,
              dataType,
              params,
            });
            return;
          }

          goPage({
            path: '/opinion/Stats/Detail',
            filter: {
              filter: getNewStatsDetailFilter({
                filter,
                dataType: 'keyword',
                params,
              }),
              statsDetailType,
              statsDetailChartsData: {
                data: keywordLineData,
                dataType,
              },
            },
          });
        },
      }}
    /> // 因为news页面的高度不统一 所以把之前312改了
  );
}
